import { useParams } from "react-router-dom"
import { ManageOpportunity } from "../Opportunities/ManageOpportunityButton"

export default function Opportunity() {
  const params = useParams()
  const { opportunityId } = params

  return (
    <div style={{ background: '#f5f5f5', padding: '20px' }}>
      <ManageOpportunity opportunityId={opportunityId} />
    </div>
  )
}